/*! Mama & Mini PDP helpers — deferred, scoped */
(function () {
  'use strict';
  if (window.__bfMmPdp) return;
  window.__bfMmPdp = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-bf-mm]');
    if (!root) return;
    document.body.classList.add('bf-mm-page');

    /* Label hints near Mom/Mini option legends when Horizon markup allows */
    document.querySelectorAll('legend, .option-label, label').forEach(function (el) {
      var t = (el.textContent || '').trim();
      if (/^Mom size$/i.test(t) && !el.querySelector('.bf-mm-option-hint')) {
        var h = document.createElement('span');
        h.className = 'bf-mm-option-hint';
        h.textContent = 'Choose your size';
        el.appendChild(document.createElement('br'));
        el.appendChild(h);
      }
      if (/^Mini size$/i.test(t) && !el.querySelector('.bf-mm-option-hint')) {
        var h2 = document.createElement('span');
        h2.className = 'bf-mm-option-hint';
        h2.textContent = 'Choose baby/kids size';
        el.appendChild(document.createElement('br'));
        el.appendChild(h2);
      }
    });

    var dialog = document.getElementById('bf-mm-size-guide');
    document.querySelectorAll('[data-bf-mm-open-guide]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog && typeof dialog.showModal === 'function') dialog.showModal();
        else if (dialog) dialog.setAttribute('open', '');
      });
    });
    document.querySelectorAll('[data-bf-mm-close-guide]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (dialog && typeof dialog.close === 'function') dialog.close();
        else if (dialog) dialog.removeAttribute('open');
      });
    });

    /* Oct 22, 2026 (Grok): on phones the Mama & Mini bar steps aside while the main buy buttons (and the add-on box under them)
       or the footer are on screen, so it never covers the selected size, price or add-on. Same rule the theme bar follows (bf-fixes-pdp.js). */
    (function () {
      var bar = document.querySelector('.bf-mm-sticky');
      var block = document.querySelector('.buy-buttons-block') || document.querySelector('form[action="/cart/add"]');
      if (!bar || !block || !('IntersectionObserver' in window)) return;
      var look = document.querySelector('[data-bf-look]');
      var foot = document.querySelector('footer');
      var vis = new Map();
      function upd() {
        var away = false; vis.forEach(function (v) { if (v) away = true; });
        bar.classList.toggle('bf-mm-sticky--away', away);
        if (away) bar.setAttribute('aria-hidden', 'true'); else bar.removeAttribute('aria-hidden');
        bar.inert = away;
      }
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { vis.set(e.target, e.isIntersecting); }); upd(); }, { threshold: 0 });
      [block, look, foot].forEach(function (el) { if (el) io.observe(el); });
    })();

    var stickyBtn = document.querySelector('[data-bf-mm-sticky-atc]');
    var formBtn = document.querySelector('form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] button[name="add"], .product-form__submit, button[name="add"]');
    if (stickyBtn && formBtn) {
      stickyBtn.addEventListener('click', function () {
        formBtn.click();
      });
    }

    /* Sync sticky price if price node exists */
    /* BF sale display (Oct 22, 2026): when the main price shows the sale markup, mirror it (sale price + 15% off badge, no strikethrough) */
    var priceHost = document.querySelector('.product-details product-price, product-price');
    var priceEl = document.querySelector('.price, [data-product-price], .product__price, .price__regular');
    var stickyPrice = document.querySelector('[data-bf-mm-sticky-price]');
    function bfSyncSticky() {
      var sale = priceHost && priceHost.querySelector('[data-bf-native-sale], [data-bf-sale]');
      if (sale) { stickyPrice.innerHTML = sale.outerHTML; return; }
      var el = document.querySelector('.price, [data-product-price], .product__price, .price__regular');
      if (el) stickyPrice.textContent = el.textContent.trim();
    }
    if (stickyPrice && (priceHost || priceEl)) {
      bfSyncSticky();
      try {
        var mo = new MutationObserver(bfSyncSticky);
        mo.observe(priceHost || priceEl, { childList: true, subtree: true, characterData: true });
      } catch (e) {}
    }
  });
})();
